import { render, staticRenderFns } from "./editDialogLive.vue?vue&type=template&id=2ab9546a"
import script from "./editDialogLive.vue?vue&type=script&lang=ts"
export * from "./editDialogLive.vue?vue&type=script&lang=ts"
import style0 from "./editDialogLive.vue?vue&type=style&index=0&id=2ab9546a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports